import React, { useState } from "react";
import { Toaster, toast } from "react-hot-toast";
import { createMeadiaSource } from "../Services/APIService";
import { useLocation, useNavigate } from "react-router-dom";

interface CreateCardProps {
  onCreateComplete?: (data: viewdata) => void;
  onCancel: () => void;
}

interface FormData {
  sourceName: string;
}
interface viewdata {
  sourceId: number;
  sourceName: string;
  isActive: boolean;
  createdBy: number;
  createdOn: string;
}

const CreateMeadiaSourceCard: React.FC<CreateCardProps> = ({
  onCreateComplete,
  onCancel,
}) => {
  const [formData, setFormData] = useState<FormData>({
    sourceName: "",
  });
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const requiredField = <span className="text-danger ms-1">*</span>;

  const handleStateNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setFormData((prev) => ({
      ...prev,
      sourceName: value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);

    if (!formData.sourceName.trim()) {
      setError("Please enter a valid Source Name");
      return;
    }

    try {
      setIsLoading(true);

      const userId = localStorage.getItem("UserId");

      if (!userId) {
        throw new Error("User ID not found in localStorage");
      }

      const payload = {
        sourceName: formData.sourceName.trim().replace(/\s+/g, " "),
        tenantId: parseInt(localStorage.getItem("tenantId") || "0"),
        createdBy: parseInt(userId),
      };

      const result = await createMeadiaSource(payload);

      if (result.isCreated) {
        const mappedData: viewdata = {
          sourceId: result.data.sourcE_ID,
          sourceName: result.data.sourcE_NAME,
          isActive: result.data.iS_ACTIVE,
          createdBy: result.data.createD_BY,
          createdOn: result.data.createD_ON,
        };
        toast.success(result.message || "Media Source Created Successfully!");
        setFormData({ sourceName: "" });
        if (onCreateComplete) {
          onCreateComplete(mappedData);
        }
      } else {
        throw new Error(result.message || "Failed to create media source");
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : "An error occurred");
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = () => {
    setFormData({ sourceName: "" });
    setError(null);
    onCancel();
  };

  return (
    <div className="card mb-4">
      <div className="card-header carHeaderWithBtn">
        <h5 className="card-title mb-0">Create Media Source</h5>
      </div>
      <div className="card-body">
        <form onSubmit={handleSubmit}>
          {error && (
            <div className="alert alert-danger text-danger" role="alert">
              {error}
            </div>
          )}
          <div className="row">
            <div className="col-12 col-lg-4 mb-3">
              <label htmlFor="sourceName" className="form-label">
                Source Name{requiredField}
              </label>
              <input
                type="text"
                id="sourceName"
                name="sourceName"
                className="form-control form-control-lg"
                placeholder="Enter Source Name"
                value={formData.sourceName}
                onChange={handleStateNameChange}
                required
              />
            </div>
            <div className="col-12">
              <button
                type="submit"
                className="btn btn-primary me-2"
                disabled={isLoading}
              >
                {isLoading ? "Creating..." : "Submit"}
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleCancel}
              >
                Cancel
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateMeadiaSourceCard;
